import { Component, Input, forwardRef, inject } from "@angular/core";
import { AggregateCriteria, IAggregate } from "@tylertech/tyler-api-types";

import { AggregateHelperService } from "../../services";
import { AggregateCardComponent } from "../aggregateCard/aggregateCard.component";

@Component({
    selector: "standard-task",
    templateUrl: "./standardTask.tmpl.html",
    imports: [
        forwardRef(() => AggregateCardComponent),
    ]
})
export class StandardTaskComponent
{
    private readonly $aggregateHelperService = inject(AggregateHelperService);

    @Input()
    aggregate: IAggregate;

    @Input()
    aggregateCriteria: AggregateCriteria;

    get isHidden(): boolean
    {
        return this.$aggregateHelperService.isHidden(this.aggregate);
    }
}
